// Interpreta a data/hora exatamente como gravada no servidor, ignorando
// qualquer sufixo de fuso (Z, +00:00 etc.) que a API venha a incluir.
export function parseServerDate(raw) {
  const texto = String(raw || '');
  const m = texto.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/);
  if (!m) return new Date(texto);
  const [, ano, mes, dia, hh, mm, ss] = m;
  return new Date(Number(ano), Number(mes) - 1, Number(dia), Number(hh), Number(mm), Number(ss));
}
